<template>
  <div id="inside" style="">
    <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
      <div class="container justify-content-center pt-0">
        <button
          class="navbar-toggler navbar-toggler-right border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbar3"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse text-center justify-content-center"
          id="navbar3"
        >
          <ul class="navbar-nav justify-content-between">
            <li
              v-bind:class="[
                this.currentPage !== 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link active" @click="home" style="cursor: pointer"
                >Propostas</a
              >
            </li>
            <li
              v-bind:class="[
                this.currentPage === 'meusAcordos'
                  ? 'nav-item border-bottom border-info mx-5 mb-2'
                  : 'nav-item mx-5',
              ]"
            >
              <a class="nav-link" @click="meusAcordos" style="cursor: pointer"
                >Acordos
                <span
                  class="badge badge-primary badge-pill"
                  v-if="agreements && agreements.length"
                  >{{ agreements.length }}</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item completed">
              <div class="step-counter"></div>
            </div>
            <div class="stepper-item completed">
              <div class="step-counter"></div>
            </div>
            <div class="stepper-item active">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12 mt-3">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="mb-0" style="color: #3a4148; font-weight: bold">
              Pronto, seu boleto foi gerado! <br /><br />
              Fique atento ao vencimento, o não pagamento na data cancela o
              acordo.
            </h5>
          </div>
        </div>
      </div>
      <div class="d-inline-flex flex-wrap flex-column col-lg-12 mt-3">
        <div class="">
          <p class="text-info mt-4 mb-1">Linha digitável:</p>
          <!-- <a
                  class="btn btn-link float-right mr-1"
                  style="cursor: pointer"
                  ><i class="fa fa-clone text-body"></i>
                </a> -->
          <p
            class="codebar"
            style="cursor: pointer"
            @click="copiarLinhaDigitável(boleto && boleto.LINHADIGITAVEL)"
          >
            {{ boleto && boleto.LINHADIGITAVEL }}
          </p>
          <p
            class="text-info float-left mb-4"
            style="font-size: 12px; cursor: pointer"
            @click="copiarLinhaDigitável(boleto && boleto.LINHADIGITAVEL)"
          >
            Clique para copiar
          </p>
          <button
            class="btn btn-pill2 btn-block text-left my-4"
            style="cursor: pointer"
            @click="baixarBoleto"
            :disabled="loadingDownloadBoleto || loading || !boleto"
          >
            <i class="fa fa-arrow-right float-right mt-2"></i>
            <img src="/img/download.svg" class="pr-4 pl-1" /> Baixar boleto
          </button>
          <h6>Ou receba por outros canais</h6>
          <button
            class="btn btn-pill2 btn-block text-left my16 mb-3"
            type="button"
            disabled
          >
            <i class="fa fa-arrow-right float-right mt-2"></i>
            <img src="/img/whatsapp.svg" class="pr-4 pl-1" />
            Receber por WhatsApp
          </button>
          <button
            class="btn btn-pill2 btn-block text-left my16 mb-3"
            type="button"
            :disabled="loadingDownloadBoleto || loading || !boleto"
            @click="openModalInformarContatos('sms')"
            style="cursor: pointer"
          >
            <i class="fa fa-arrow-right float-right mt-2"></i>
            <img src="/img/sms.svg" class="pr-4 pl-1" /> Receber por SMS
          </button>
          <button
            class="btn btn-pill2 btn-block text-left mb-3"
            type="button"
            :disabled="loadingDownloadBoleto || loading || !boleto"
            @click="openModalInformarContatos('email')"
            style="cursor: pointer"
          >
            <i class="fa fa-arrow-right float-right mt-2"></i>
            <img src="/img/arroba.svg" class="pr-4 pl-1" />&nbsp;Receber por
            E-MAIL
          </button>
        </div>

        <button
          class="btn btn-primary btn-block text-white mt-5"
          style="cursor: pointer !important"
          @click="home"
        >
          CONCLUIR
        </button>

        <div class="card" v-if="loading">
          <ProgressLoading v-bind:loading="loading" />
        </div>
      </div>

      <!-- MODAIS -->
      <div
        class="modal fade"
        id="informarContatos"
        style="background-color: #000000a3"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: bold">
                Informe seus contatos
              </h5>
              <button type="button" @click="closeModalInformarContatos()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <form class="mb-0" @submit.prevent="sentBill">
                <div class="form-group my-0">
                  <div class="form-group mb-1" v-if="from === 'sms'">
                    <label>Informe o número de telefone</label>
                    <the-mask
                      type="tel"
                      class="form-control form-control-sm"
                      style="border-radius: 4px"
                      placeholder="(00) 00000-0000"
                      v-model="phoneNumber"
                      mask="(##) # ####-####"
                    />
                  </div>
                  <div class="form-group mt-2" v-if="from === 'email'">
                    <label>Informe seu e-mail</label>
                    <input
                      type="email"
                      class="form-control form-control-sm"
                      style="border-radius: 4px"
                      placeholder="exemplo@exemplo.com"
                      v-model="email"
                    />
                  </div>
                </div>
              </form>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button
                type="button"
                class="btn btn-primary btn-block mt-4 text-white"
                @click="sentBill()"
                :disabled="loadingSentBill"
              >
                RECEBER BOLETO
              </button>
              <button
                class="btn btn-link btn-block"
                :disabled="loadingSentBill"
                @click="closeModalInformarContatos()"
              >
                CANCELAR
              </button>
              <ProgressLoading v-bind:loading="loadingSentBill" />
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="boletoEnviado"
        style="background-color: #000000a3"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: bold">
                Boleto enviado!
              </h5>
              <button type="button" @click="closeModalConfirmSentBill()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <div class="form-group my-0">
                <div class="form-group mb-1">
                  <div class="">
                    <p class="" style="">
                      Seu boleto foi enviado através do canal escolhido.
                    </p>
                  </div>
                </div>
              </div>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button
                class="btn btn-primary btn-block mt-4"
                @click="closeModalConfirmSentBill()"
              >
                OBRIGADO
              </button>
              <ProgressLoading v-bind:loading="loading" />
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="boletoBaixado"
        style="background-color: #000000a3"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: bold">
                Boleto baixado!
              </h5>
              <button type="button" @click="closeModalConfirmDownloadBill()">
                <span style="font-size: 12pt">×</span>
              </button>
            </div>
            <div class="modal-body pt-0">
              <div class="form-group my-0">
                <div class="form-group mb-1">
                  <div class="">
                    <p class="" style="">
                      Seu boleto foi baixado. Se precisar de uma segunda via,
                      acesse a guia acordos.
                    </p>
                  </div>
                </div>
              </div>
              <!-- :disabled="
                isAboveThan ||
                isBelowThan ||
                loading ||
                !convertCurrencyToFloat(entryValue) > 0
              " -->
              <button
                class="btn btn-primary btn-block mt-4"
                @click="closeModalConfirmDownloadBill()"
              >
                OBRIGADO
              </button>
              <ProgressLoading v-bind:loading="loading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  isValidPhoneNumber,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import { TheMask } from "vue-the-mask";

export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading,
    TheMask,
  },
  data() {
    return {
      containParcel: false,
      loading: true,
      loadingAgreement: false,
      loadingDownloadBoleto: false,
      loadingSentBill: false,
      parcelado: false,
      currentPage: "concluir",
      openContractDetails: true,
      largura: null,
      agreements: [],
      responseAgreement: null,
      phoneNumber: null,
      email: null,
      from: "sms",
      userAdm: null,
      ipUser: "",
    };
  },
  async created() {
    this.largura = window.screen.width;
    const fromRoute = this.$route.params.responseAgreement;
    if (fromRoute) {
      this.responseAgreement = fromRoute;
      localStorage.setItem("responseAgreement", JSON.stringify(fromRoute));
    } else {
      try {
        this.responseAgreement = JSON.parse(
          localStorage.getItem("responseAgreement") || "null"
        );
      } catch (e) {
        this.responseAgreement = null;
      }
    }

    const agreements = localStorage.getItem("agreements");
    try {
      const parsed = agreements ? JSON.parse(agreements) : [];
      this.agreements = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      this.agreements = [];
    }

    this.ipUser = localStorage.getItem("ipUser") || "";
    try {
      this.userAdm = JSON.parse(localStorage.getItem("userAdm") || "null");
    } catch (e) {
      this.userAdm = null;
    }
    this.loading = false;
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,

    ...mapActions("minhasDividas", [
      "ActionDividaNegociar",
      "ActionContractsAgreementResume",
      "ActionContractsAgreement",
      "ActionLogDownloadBoleto",
      "ActionLogCopyDigitableLine",
      "ActionSendEmailOrSmsText",
      "ActionDownloadBoleto",
    ]),

    async acordoFechado() {
      this.loadingAgreement = true;

      this.loadingAgreement = false;

      this.$router.push({
        name: "meusBoletos",
        params: { agreement: this.responseAgreement },
      });
    },

    containParcelas() {
      var array = this.contractNegotiable.filter(
        (f) =>
          f.selected &&
          f.Parcelas.filter((filter) => filter.selected == true).length > 0
      );
      this.containParcel = array.length > 0;
    },

    getParcelas(idContrato) {
      let parcelas = "";
      this.contractNegotiable
        .filter((f) => f.selected)
        .forEach((ctr) => {
          if (ctr.NumeroContrato == idContrato)
            parcelas = ctr.Parcelas.filter((filter) => filter.selected == true)
              .map((i) => i.NumeroParcela)
              .join(", ");
        });

      return parcelas;
    },

    home() {
      localStorage.setItem("currentPage", "dashboard");
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard", params: { from: "concluir" }  });
      }
    },

    meusAcordos() {
      localStorage.setItem("currentPage", "meusAcordos");
      this.$router.push({ name: "meusAcordos" });
    },

    openCloseContractsDetails() {
      this.openContractDetails = !this.openContractDetails;
    },

    voltar() {
      this.$router.push({
        name: "dashboard",
      });
    },

    async sentBill() {
      this.loadingSentBill = true;
      try {
        const linha = this.boleto && this.boleto.LINHADIGITAVEL;
        if (!linha) throw new Error("Linha digitável não encontrada.");

        if (this.from === "sms") {
          await this.sendSms(linha);
        } else if (this.from === "email") {
          await this.sendEmail(linha);
        } else {
          throw new Error("Selecione SMS ou e-mail.");
        }

        this.closeModalInformarContatos();
        this.openModalConfirmSentBill();
      } catch (e) {
        const message = e && e.message;
        const known =
          message === "Informe um telefone válido!" ||
          message === "Informe um e-mail válido!" ||
          message === "Linha digitável não encontrada." ||
          message === "Selecione SMS ou e-mail.";
        if (known && this.flashMessage) {
          this.flashMessage.show({
            timeout: 2000,
            status: "error",
            title: "Ocorreu um erro",
            message,
          });
        }
      } finally {
        this.loadingSentBill = false;
      }
    },

    async sendSms(linhaDigitavel) {
      if (!isValidPhoneNumber(this.phoneNumber || "")) {
        throw new Error("Informe um telefone válido!");
      }

      await this.ActionSendEmailOrSmsText({
        LinhaDigitavel: linhaDigitavel,
        Email: null,
        PhoneNumber: this.phoneNumber,
        type: "sms",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        OS: navigator.platform,
        IP: this.ipUser || "",
        credor: (this.readAgreementPayload() || {}).credor || (this.responseAgreement && this.responseAgreement.CODCREDOR),
      });
      this.phoneNumber = "";
    },

    async sendEmail(linhaDigitavel) {
      const email = String(this.email || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        throw new Error("Informe um e-mail válido!");
      }

      await this.ActionSendEmailOrSmsText({
        LinhaDigitavel: linhaDigitavel,
        Email: email,
        PhoneNumber: null,
        type: "email",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        OS: navigator.platform,
        IP: this.ipUser || "",
        credor: (this.readAgreementPayload() || {}).credor || (this.responseAgreement && this.responseAgreement.CODCREDOR),
      });
      this.email = "";
    },

    copiarLinhaDigitável(linhaDigitavel) {
      if (!linhaDigitavel) return;
      const elem = document.createElement("textarea");
      elem.value = linhaDigitavel;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);

      this.flashMessage.show({
        time: 4000,
        status: "success",
        title: "Sucesso",
        blockClass: "custom-block-class",
        message: "Linha digitável foi copiada para o seu clipboard",
      });

      this.ActionLogCopyDigitableLine({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        credor: (this.readAgreementPayload() || {}).credor || (this.responseAgreement && this.responseAgreement.CODCREDOR),
        digitableLine: linhaDigitavel,
        NotesJson: {
          action: "copy_digitable_line",
          digitableLine: linhaDigitavel,
          copiedAt: new Date().toISOString(),
        },
      });
    },

    openModalInformarContatos(channel) {
      this.from = channel === "email" ? "email" : "sms";
      const modal = document.getElementById("informarContatos");
      if (!modal) return;
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalInformarContatos() {
      const modal = document.getElementById("informarContatos");
      if (!modal) return;
      modal.classList.remove("show");
      modal.style.display = "none";
      document.body.classList.remove("modal-open");
    },

    openModalConfirmSentBill() {
      // this.validateProposalOptions();
      const modal = document.getElementById("boletoEnviado");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmSentBill() {
      const modal = document.getElementById("boletoEnviado");
      if (!modal) return;
      modal.classList.remove("show");
      modal.style.display = "none";
      document.body.classList.remove("modal-open");
    },

    openModalConfirmDownloadBill() {
      // this.validateProposalOptions();
      const modal = document.getElementById("boletoBaixado");
      modal.classList.add("show");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    },

    closeModalConfirmDownloadBill() {
      const modal = document.getElementById("boletoBaixado");
      if (!modal) return;
      modal.classList.remove("show");
      modal.style.display = "none";
      document.body.classList.remove("modal-open");
    },

    async baixarBoleto() {
      if (this.loadingDownloadBoleto) return;
      this.loadingDownloadBoleto = true;
      try {
        const stored = this.readAgreementPayload();
        if (!this.isUnicaAgreement(stored)) {
          this.baixarPdfDoAcordo();
          return;
        }

        if (!stored || !stored.credor || !stored.company) {
          throw new Error("Dados do acordo indisponíveis.");
        }

        const isUnica = String(stored.credor || "").toUpperCase() === "UNICA";
        const regis = this.resolveRegis(stored);
        if (isUnica && !regis) {
          throw new Error("Dados do acordo indisponíveis.");
        }
        const document = isUnica ? regis : stored.document || regis;
        const agreement = this.responseAgreement || {};
        const prest =
          agreement.PRESTACOES &&
          agreement.PRESTACOES.PREST &&
          agreement.PRESTACOES.PREST[0];
        const issuedDue = this.toIsoDate(
          (prest && prest.DATVENCI) || (this.boleto && this.boleto.DATVENCI)
        );
        const dueDate = issuedDue || stored.dueDate;
        const original = (stored.installments && stored.installments[0]) || {};
        const resp = await this.ActionDownloadBoleto({
          document,
          regis,
          credor: stored.credor,
          company: stored.company,
          dueDate,
          installments: [
            {
              contract: agreement.CODPARCE || (prest && prest.DESCONTR) || original.contract,
              product: (prest && prest.CODPRODUT) || "PARC",
              dueInstallmentDate: dueDate || original.dueInstallmentDate,
            },
          ],
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser || "",
        });

        const boleto =
          (resp && resp.DADOBOLETO && resp.DADOBOLETO[0]) ||
          (resp && resp.DADODOBOLETO && resp.DADODOBOLETO[0]) ||
          null;
        if (!boleto || !boleto.BASE64) {
          throw new Error("Não foi possível baixar o boleto.");
        }

        this.downloadBase64(boleto.BASE64);
        this.ActionLogDownloadBoleto({
          IP: this.ipUser || "",
          OS: typeof navigator !== "undefined" ? navigator.platform : "",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          credor: stored.credor,
          digitableLine: boleto.LINHADIGITAVEL || (this.boleto && this.boleto.LINHADIGITAVEL),
          NotesJson: {
            action: "download_boleto",
            digitableLine: boleto.LINHADIGITAVEL || undefined,
            downloadedAt: new Date().toISOString(),
          },
        });
        this.openModalConfirmDownloadBill();
      } catch (e) {
        const apiMessage = e && e.data && e.data.message;
        if (apiMessage) return;
        const message = e && e.message;
        if (this.flashMessage) {
          this.flashMessage.show({
            timeout: 2000,
            status: "error",
            title: "Ocorreu um erro",
            message:
              message === "Dados do acordo indisponíveis." ||
              message === "Não foi possível baixar o boleto."
                ? message
                : "Não foi possível baixar o boleto.",
          });
        }
      } finally {
        this.loadingDownloadBoleto = false;
      }
    },

    isUnicaAgreement(stored) {
      const credor =
        (stored && stored.credor) ||
        (this.responseAgreement && this.responseAgreement.CODCREDOR);
      return String(credor || "").toUpperCase() === "UNICA";
    },

    baixarPdfDoAcordo() {
      const base64 = this.boleto && this.boleto.BASE64;
      if (!base64 || typeof base64 !== "string") {
        if (this.flashMessage) {
          this.flashMessage.show({
            timeout: 2000,
            status: "error",
            title: "Ocorreu um erro",
            message: "Não foi possível baixar o boleto.",
          });
        }
        return;
      }

      this.downloadBase64(base64);
      this.ActionLogDownloadBoleto({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        credor: (this.readAgreementPayload() || {}).credor || (this.responseAgreement && this.responseAgreement.CODCREDOR),
        digitableLine: this.boleto && this.boleto.LINHADIGITAVEL,
        NotesJson: {
          action: "download_boleto",
          digitableLine: (this.boleto && this.boleto.LINHADIGITAVEL) || undefined,
          downloadedAt: new Date().toISOString(),
        },
      });
      this.openModalConfirmDownloadBill();
    },

    toIsoDate(value) {
      if (!value) return null;
      const text = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10);
      const match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
      if (match) return `${match[3]}-${match[2]}-${match[1]}`;
      return null;
    },

    readAgreementPayload() {
      try {
        return JSON.parse(localStorage.getItem("agreementPayload") || "null");
      } catch (e) {
        return null;
      }
    },

    resolveRegis(stored) {
      if (stored && stored.regis) return String(stored.regis);

      const contractIds = new Set(
        ((stored && stored.installments) || []).map((i) => String(i.contract))
      );
      try {
        const contracts = JSON.parse(localStorage.getItem("contracts") || "[]");
        const match = (contracts || []).find(
          (c) =>
            c &&
            c.regis &&
            contractIds.has(String(c.contrato)) &&
            String(c.credor || "").toUpperCase() ===
              String((stored && stored.credor) || "").toUpperCase()
        );
        if (match) return String(match.regis);
      } catch (e) {
        /* payload antigo segue com document */
      }

      return stored && stored.document ? String(stored.document) : "";
    },

    downloadBase64(base64) {
      const linkSource = `data:application/pdf;base64,${base64}`;
      const downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      downloadLink.href = linkSource;
      downloadLink.download = "boleto-parcela.pdf";
      downloadLink.click();
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("minhasDividas", [
      "agreementResume",
      "contractNegotiable",
      "contractNegotiableOptions",
    ]),
    boleto() {
      const list =
        (this.responseAgreement && this.responseAgreement.DADOBOLETO) ||
        (this.responseAgreement && this.responseAgreement.DADODOBOLETO) ||
        [];
      return list[0] || null;
    },
  },
};
</script>
<style scoped>
</style>
